import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { ContactForm } from '../components/ContactForm';

export default function Contact() {
  return (
    <div className="pt-20">
      <Helmet>
        <title>Kontakt DK Grøn Service | Få Et Uforpligtende Tilbud i Dag</title>
        <meta name="description" content="Kontakt DK Grøn Service for et uforpligtende tilbud på ejendomsservice, græsslåning eller havearbejde. Ring på 42 44 23 59 eller send en besked – vi svarer hurtigt!" />
        <meta property="og:title" content="Kontakt DK Grøn Service | Få Et Uforpligtende Tilbud i Dag" />
        <meta property="og:description" content="Kontakt DK Grøn Service for et uforpligtende tilbud på ejendomsservice, græsslåning eller havearbejde. Ring på 42 44 23 59 eller send en besked." />
        <meta property="og:type" content="website" />
      </Helmet>

      <section className="py-24 bg-emerald-50">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center space-y-6">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-emerald-950">Kontakt os</h1>
            <p className="text-xl text-emerald-800/70 leading-relaxed">
              Har du spørgsmål til vores ydelser, eller ønsker du et uforpligtende tilbud? Vi sidder klar til at hjælpe dig.
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
            {/* Contact Info */}
            <div className="lg:col-span-5 space-y-12">
              <div className="space-y-8">
                <h2 className="text-3xl font-bold text-emerald-950">Direkte kontakt</h2>
                <div className="space-y-6">
                  <a
                    href="tel:+4542442359"
                    className="flex items-center gap-6 group"
                  >
                    <div className="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-2xl flex items-center justify-center shrink-0 group-hover:bg-emerald-600 group-hover:text-white transition-all duration-300">
                      <Phone className="w-8 h-8" />
                    </div>
                    <div>
                      <p className="text-sm font-bold text-emerald-600 uppercase tracking-wider">Ring til os</p>
                      <p className="text-2xl font-bold text-emerald-950">42 44 23 59</p>
                    </div>
                  </a>

                  <a
                    href="mailto:Djensen2@me.com"
                    className="flex items-center gap-6 group"
                  >
                    <div className="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-2xl flex items-center justify-center shrink-0 group-hover:bg-emerald-600 group-hover:text-white transition-all duration-300">
                      <Mail className="w-8 h-8" />
                    </div>
                    <div>
                      <p className="text-sm font-bold text-emerald-600 uppercase tracking-wider">Send en mail</p>
                      <p className="text-2xl font-bold text-emerald-950">Djensen2@me.com</p>
                    </div>
                  </a>
                </div>
              </div>

              <div className="space-y-8">
                <h2 className="text-3xl font-bold text-emerald-950">Information</h2>
                <div className="space-y-6">
                  <div className="flex items-start gap-6">
                    <div className="w-16 h-16 bg-emerald-50 text-emerald-600 rounded-2xl flex items-center justify-center shrink-0">
                      <MapPin className="w-8 h-8" />
                    </div>
                    <div>
                      <p className="text-sm font-bold text-emerald-600 uppercase tracking-wider">Område</p>
                      <p className="text-lg text-emerald-900 font-medium">Vi dækker hele lokalområdet og omegn.</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-6">
                    <div className="w-16 h-16 bg-emerald-50 text-emerald-600 rounded-2xl flex items-center justify-center shrink-0">
                      <Clock className="w-8 h-8" />
                    </div>
                    <div>
                      <p className="text-sm font-bold text-emerald-600 uppercase tracking-wider">Svartid</p>
                      <p className="text-lg text-emerald-900 font-medium">Vi bestræber os på at svare inden for 24 timer.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-emerald-900 p-10 rounded-[3rem] text-white space-y-4">
                <h3 className="text-2xl font-bold">DK Grøn Service</h3>
                <p className="text-emerald-100/70">
                  Professionel ejendomsservice drevet af personlig kontakt og godt håndværk.
                </p>
                <div className="pt-4 border-t border-emerald-800">
                  <p className="text-sm text-emerald-400">CVR: 46182588</p>
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="lg:col-span-7 bg-emerald-50/50 p-8 md:p-12 rounded-[3rem] border border-emerald-100 shadow-sm">
              <div className="mb-10">
                <h2 className="text-3xl font-bold text-emerald-950 mb-4">Send os en besked</h2>
                <p className="text-emerald-800/60">
                  Udfyld formularen herunder, så vender vi tilbage til dig hurtigst muligt.
                </p>
              </div>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
